<dgx-modal [canCancel]="false" [useDefaultSubmitButton]="false">
  <ng-container class="modal-header">
    <span class="strong par guts-p-l-2 guts-p-t-1-half guts-p-b-2">{{
      profile.name
    }}</span>
  </ng-container>

  <ng-container class="modal-body">
    <div>
      <dgx-tab-navigation-routerless
        [tabList]="tabList"
        [defaultActiveTabId]="defaultTab"
        (updateSelectedTab)="switchTab($event)"
      ></dgx-tab-navigation-routerless>

      <dgx-following-tab
        *ngIf="selectedTab === 'following'"
        [profile]="profile"
        [ownerIsViewing]="ownerIsViewing"
      ></dgx-following-tab>

      <dgx-followers-tab
        *ngIf="selectedTab === 'followers'"
        [profile]="profile"
        [ownerIsViewing]="ownerIsViewing"
      ></dgx-followers-tab>

      <dgx-groups-tab
        *ngIf="selectedTab === 'groups'"
        [profile]="profile"
        [ownerIsViewing]="ownerIsViewing"
      ></dgx-groups-tab>
    </div>
  </ng-container>

  <ng-container class="modal-footer">
    <div class="left-text">
      <button
        df-button
        dfButtonType="passive"
        data-dgat="profile-social-modal-8f9"
        class="btn btn-passive no-border bg-color-ebony-a08 color-ebony profile-button left-text"
        (click)="closeModal()"
      >
        {{ i18n.Core_Cancel }}
      </button>
    </div>
  </ng-container>
</dgx-modal>
